<sh-detail-list-layout [detailsCollapsed]="!$detailPanelOpen()" [filtersCollapsed]="!$filterPanelOpen()" (toggleFilters)="toggleFilterPanel($event)">
    <ng-template #topContent>
        <ng-content select="[aboveSearchBar]"></ng-content>
        <sh-search-bar [enableAdvancedSearch]="true"></sh-search-bar>
    </ng-template>

    <ng-template #filtersContent>
        <ng-content select="[filtersContent]"></ng-content>
    </ng-template>

    <ng-template #filtersCollapsedContent>
        <sh-icon-badge [icon]="'filter'" [count]="$filterCount()" (click)="toggleFilterPanel(false)"></sh-icon-badge>
    </ng-template>

    <ng-template #hierarchyContent>
        <ng-content select="[hierarchyContent]"></ng-content>
    </ng-template>

    <ng-template #hierarchyCollapsedContent>
        <ng-content select="[hierarchyCollapsedContent]"></ng-content>
    </ng-template>

    <ng-template #mainContent>
        <ng-content select="[abovePageHeader]"></ng-content>
        <div class="sh-template-stack">
            <div class="sh-template-stack__item">
                <sh-generic-overview
                    [searchBarMode]="$searchBarMode()"
                    [searchBarActionItems]="searchBarActionItems$ | async"
                    [fieldSearchOptions]="$fieldSearchOptions()"
                    [displayMode]="$view()"
                    [displayOptions]="$viewOptions()"
                    [showViewToggle]="$showViewToggle()"
                    [sortInfo]="$sort()"
                    [sortOptions]="$sortOptions()"
                    [allowSort]="$allowSort()"
                    [resultsPerPageOptions]="$pageSizeOptions()"
                    [paginatedResults]="searchPageResults$ | async"
                    [actionItems]="actions$ | async"
                    [contextActionGroup]="contextActions$ | async"
                    [pictureFillMode]="$imageFitModeSetting()"
                    [areItemsClickable]="$allowItemClick()"
                    [availableSelect]="$allowSelection()"
                    [canBatchSelect]="$allowBatchSelection()"
                    [allSelected]="initialBatchSelect"
                    [selectedItems]="selectedItems$ | async"
                    [activeItem]="$activeItem()"
                    [columns]="columns$ | async"
                    [columnOptions]="columnOptions$ | async"
                    [isLoading]="loading$ | async"
                    [hasError]="error$ | async"
                    [noItemsSelectedLabelKey]="$noItemsSelectedLabelKey()"
                    [itemsSelectedLabelKey]="$itemsSelectedLabelKey()"
                    [xxResultsLabelKey]="$xxResultsLabelKey()"
                    [noResultsLabelKey]="$noResultsLabelKey()"
                    [disableSelectMessage]="'general.no-batch-select'"
                    (paginationInfoChanged)="onPaginationInfoChanged($event)"
                    (sortInfoChanged)="onSortInfoChanged($event)"
                    (displayModeChanged)="onViewChanged($event)"
                    (itemClicked)="onRowClicked($event)"
                    (actionModeChanged)="onActionModeChanged($event)"
                    (thumbnailClicked)="onThumbnailClicked($event)"
                    (itemsChecked)="onSelectedItemsChanged($event)"
                    (columnSelectionChanged)="onColumnSelectionChanged($event)"
                ></sh-generic-overview>
            </div>
        </div>
    </ng-template>

    <ng-template #detailContent>
        <ng-content select="[detailContent]"></ng-content>
    </ng-template>
</sh-detail-list-layout>
